import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "toast-container position-fixed bottom-0 end-0 p-3" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "toast-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-alert me-2" }, null, -1)
const _hoisted_5 = { class: "me-auto" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-no-styling p-0",
  "data-bs-dismiss": "toast",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" })
], -1)
const _hoisted_7 = { class: "toast-body" }

import Toast from 'bootstrap/js/dist/toast';
// @ts-ignore
import { onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveToast',
  props: {
    store: {},
    toastTitle: {}
  },
  setup(__props: any) {

const props = __props;

// @ts-ignore
const toasts = ref(null);



onMounted( async () => {
  if(toasts.value){
    toasts.value.map(async toast => {
      if (props.store.errors.length > 0) {
        await showToast(toast);
      }
    });
  }
})

async function showToast(toast){
  await Toast.getOrCreateInstance(toast).show();
}

watch(toasts, async (newValue, oldValue) => {
  toasts.value.map(async(toast) => {
    await showToast(toast);
  });
}, {deep: true});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.store.errors, (error, key) => {
      return (_openBlock(), _createElementBlock("div", {
        id: 'liveToast-' + key,
        class: "toast",
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        ref_for: true,
        ref_key: "toasts",
        ref: toasts,
        "data-bs-delay": "20000"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.toastTitle), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString(error), 1)
      ], 8, _hoisted_2))
    }), 256))
  ]))
}
}

})